import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
export interface Observation {
  id: string;
  title: string;
  category: 'positive' | 'negative' | 'question' | 'neutral';
  level: 'Architecture' | 'Tech' | 'Product' | 'Business';
  expertVerified: boolean;
}

export interface ScansObservationsTableSignature {
  Args: {
    observations: Observation[];
  };
  Blocks: {
    default: [];
  };
  Element: HTMLTableElement;
}

export default class ScansObservationsTable extends Component<ScansObservationsTableSignature> {
  declare model: any;

  @tracked slideoverIsOpen = false;
  @tracked selectedIndex: number = -1;
  @tracked selectedObservationId: string | undefined;

  @action
  openSlideover(index: number) {
    this.selectedIndex = index;
    this.slideoverIsOpen = true;
  }

  @action
  closeSlideover() {
    this.selectedIndex = -1;
    this.setSelectedObservationId(undefined);
    this.slideoverIsOpen = false;
  }

  @action
  setSelectedObservationId(id: string | undefined) {
    this.selectedObservationId = id;
  }
}
